namespace e5.TransformMode {
    class TransformModeRectangle implements ITransformMode {
        public extract(transform: Transform, matrix: Matrix3d): void {
            var globalBounds = Rect.getBounds(transform.element);
            matrix.prependPosition(globalBounds.x, globalBounds.y, 0);
            var scX = 1;
            if (globalBounds.width !== transform.element.offsetWidth)
                scX = globalBounds.width / transform.element.offsetWidth;
            var scY = 1;
            if (globalBounds.height !== transform.element.offsetHeight)
                scY = globalBounds.height / transform.element.offsetHeight;
            if (scX !== 1 && scY !== 1)
                matrix.appendScale(scX, scY, 1);
        }
    }

    export const Rectangle = new TransformModeRectangle();
}